import { Chip } from '../ui/index.js'
import { TASK_STATUS, type TaskStatus } from '@ovrsee/shared'

/**
 * Tones taken from the prototype's StatusChip map in manager-tasks.jsx, so the stored
 * statuses render exactly as designed. Overdue is derived, never stored, which is why it
 * arrives as a separate flag rather than as a status value.
 */
const PRESENTATION: Record<TaskStatus, { label: string; color: string }> = {
  [TASK_STATUS.ASSIGNED]: { label: 'Assigned', color: 'winter' },
  [TASK_STATUS.IN_PROGRESS]: { label: 'In progress', color: 'egg_yolk' },
  [TASK_STATUS.SUBMITTED]: { label: 'Submitted', color: 'berry' },
  [TASK_STATUS.RETURNED]: { label: 'Returned', color: 'orchid' },
  [TASK_STATUS.APPROVED]: { label: 'Approved', color: 'grass_green' },
  [TASK_STATUS.BLOCKED]: { label: 'Blocked', color: 'stuck-red' },
}

export function StatusChip({ status, isOverdue = false }: { status: TaskStatus; isOverdue?: boolean }) {
  // An approved task is closed, so a stale overdue flag must not override it.
  if (isOverdue && status !== TASK_STATUS.APPROVED) {
    return <Chip label="Overdue" style={{ background: 'var(--negative-bg)', color: 'var(--negative)', borderColor: 'transparent' }} />
  }
  const presentation = PRESENTATION[status]
  const style =
    presentation.color === 'winter'
      ? { background: 'var(--info-bg)', color: 'var(--info)', borderColor: 'transparent' }
      : presentation.color === 'egg_yolk'
        ? { background: 'var(--warning-bg)', color: 'var(--warning)', borderColor: 'transparent' }
        : presentation.color === 'berry'
          ? { background: 'var(--brand-soft)', color: 'var(--mauve-700)', borderColor: 'var(--mauve-200)' }
          : presentation.color === 'orchid'
            ? { background: 'var(--brand-soft)', color: 'var(--mauve-700)', borderColor: 'var(--mauve-200)' }
            : presentation.color === 'grass_green'
              ? { background: 'var(--positive-bg)', color: 'var(--positive)', borderColor: 'transparent' }
              : { background: 'var(--negative-bg)', color: 'var(--negative)', borderColor: 'transparent' }
  return <Chip label={presentation.label} style={style} />
}
